<template>
	<div class="display-flex flex-column">
		<div class="wrapper display-flex flex-row flex-align-center flex-justify-space-between">
			<div class="display-flex flex-row flex-align-center">
				<SIcon class="mr-4" :name="isCompletedIconName" width="20" height="20" />
				<SIcon class="mr-3" v-if="stepDetails.iconName" :name="stepDetails.iconName" width="20" height="20" />
				<div class="step-title">{{ stepDetails.title }}</div>
			</div>
			<DropdownRotatingArrow :rotate="isOpen" />
		</div>
		<div v-if="isOpen && stepDetails.subTitle" class="step-sub-title mt-n2">{{ stepDetails.subTitle }}</div>
	</div>
</template>

<script>
import DropdownRotatingArrow from '@/components/common/RotatingArrow/DropdownRotatingArrow.vue';

export default {
	name: 'OnBoardingSectionStepHeader',
	props: {
		isOpen: { type: Boolean },
		stepDetails: { type: Object },
	},
	components: { DropdownRotatingArrow },
	computed: {
		isCompletedIconName() {
			if (this.stepDetails.isCompleted) {
				return 'on-boarding-complete';
			} else {
				return 'on-boarding-not-complete';
			}
		},
	},
};
</script>

<style scoped lang="scss">
.wrapper {
	height: 45px;
	cursor: pointer;
}
.step-title {
	font-size: 16px;
	font-weight: bold;
	color: var(--primary-font-color);
}
.step-sub-title {
	opacity: 0.5;
	font-size: 14px;
	margin-left: 37px;
	font-weight: normal;
	color: var(--primary-font-color);
}
</style>
